import React, { useCallback } from 'react';
import i18next from 'i18next';
import { useDispatch, useSelector } from 'react-redux';
import { designSystem } from '@yola/ws-ui';
import i18n from 'src/js/modules/i18n';
import getSearchParams from 'src/js/utils/get-search-params';
import user from 'src/js/modules/user';
import GoogleButton from '../components/google-button';
import AuthMethodDivider from '../components/auth-method-divider';

const { Stack, Box } = designSystem;

const GoogleAuthContainer = () => {
  const locale = useSelector(i18n.selectors.getLocale);
  const dispatch = useDispatch();

  const authWithGoogle = useCallback(async () => {
    const searchParams = getSearchParams();
    const authParams = {
      locale,
    };

    if (searchParams.toString() && searchParams.has('next')) {
      authParams.next = searchParams.get('next');
    }

    await dispatch(user.thunks.authWithGoogle(authParams));
  }, [locale, dispatch]);

  return (
    <Box paddingBottom="spacing-2-xs">
      <Stack gap="spacing-xs">
        <GoogleButton onClick={authWithGoogle} label={i18next.t('Continue with Google')} />
        <AuthMethodDivider label={i18next.t('or')} />
      </Stack>
    </Box>
  );
};

export default GoogleAuthContainer;
